// src/pages/Success.jsx
import React from "react";
import { Link } from "react-router-dom";

const Success = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center min-vh-100"
      style={{ backgroundColor: "#f0f4f8" }}
    >
      <div className="text-center p-5 shadow rounded bg-white" style={{ maxWidth: "400px", width: "100%" }}>
        <h2 className="text-success mb-3">Registration Successful!</h2>
        <p className="mb-4">Thank you for registering. You can now go back to the homepage.</p>
        <Link to="/" className="btn btn-primary">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default Success;
